module.exports = "<app-payor-date-range-report reportPath=\"CreateRtpPdf\" LogisticarePayors=\"true\" isDateRange=\"true\" title=\"LogistiCare Florida Daily Trip\" reportName=\"LogistiCare Florida Daily Trip\" payorDropdown=\"true\" callTypeDropdown=\"true\" isPost=\"true\"> </app-payor-date-range-report>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/manager-reports/report-payors/report-payors.component.html
// module id = 2468
// module chunks = 66